(function () {
    'use strict';

    function requestForProposalResponsesSearchController($scope) {
        var vm = this;
        vm.results = [];
        vm.entityId = '';

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.entityId = toParams.entityId;
        });

    }

    requestForProposalResponsesSearchController.$inject = ['$scope'];

    angular.module('ecap.crm').controller('requestForProposalResponsesSearchController', requestForProposalResponsesSearchController);
})();
